<template>
  <div>
    <input
      v-model.trim="search"
      ref="search"
      type="text"
      :placeholder="$t('purchaseOrder.searchProductList')"
      class="form-control"
    />
    <div class="ts-mt-3 ts-border ts-border-gray-300 ts-p-3 ts-rounded max-h">
      <ts-loading-banner :loading="loading">
        <table class="ts-w-full">
          <thead>
            <tr>
              <th class="ts-bg-gray-200 ts-px-1 ts-py-1">
                {{ $t('purchaseOrder.barcode') }}
              </th>
              <th class="ts-bg-gray-200 ts-px-1 ts-py-1">
                {{ $t('purchaseOrder.name') }}
              </th>
              <th class="ts-bg-gray-200 ts-px-1 ts-py-1 ts-text-center">
                {{ $t('purchaseOrder.quantity') }}
              </th>
              <th
                class="ts-bg-gray-200 ts-px-1 ts-py-1 ts-text-center"
                style="width: 20%"
              >
                {{ $t('purchaseOrder.costThb') }}
              </th>
              <th
                class="ts-bg-gray-200 ts-px-1 ts-py-1 ts-text-center"
                style="width: 20%"
              >
                {{ $t('purchaseOrder.costUsd') }}
              </th>
              <th class="ts-bg-gray-200 ts-px-1 ts-py-1 ts-text-center"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(product, index) in getProduct({
                chosenProduct: model.po_detail,
                search: search
              })"
              :key="index"
              class="ts-cursor-pointer hover:ts-bg-gray-300 ts-border-b"
            >
              <td class="ts-whitespace-no-wrap" @click="addItem(product)">
                {{ product.barcode }}
              </td>
              <td
                class="ts-pl-1 ts-whitespace-no-wrap"
                @click="addItem(product)"
              >
                {{ product.product_name_en }}
              </td>
              <td class="ts-pl-1">
                <input
                  type="number"
                  class="form-control"
                  v-model.number="product.qty"
                  @keypress.enter="addItem(product)"
                />
              </td>
              <td class="ts-pl-1 ts-text-right ts-whitespace-no-wrap">
                <ts-currency-input
                  v-model.number="product.cost_in_bath"
                  currency="฿"
                  class="form-control ts-text-right"
                  style="width: 100%"
                  :precision="default_precision"
                  @input="onThbInput(product)"
                  @keyPressEnter="addItem(product)"
                />
              </td>
              <td class="ts-pl-1 ts-text-right ts-whitespace-no-wrap">
                <ts-currency-input
                  v-model.number="product.cost"
                  class="form-control ts-text-right"
                  style="width: 100%"
                  :currency="default_currency_sign"
                  :precision="default_precision"
                  @input="onUsdInput(product)"
                  @keyPressEnter="addItem(product)"
                />
              </td>
              <td class="ts-px-3 ts-whitespace-no-wrap">
                <a
                  href="#"
                  class="ts-text-blue-500"
                  @click.prevent="addItem(product)"
                >
                  <i class="fa fa-plus"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </ts-loading-banner>
    </div>
    <small
      ><i>{{ $t('purchaseOrder.clickToAddProduct') }}</i></small
    >
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'productList',
  props: ['value'],
  data () {
    return {
      loading: false,
      search: '',
      model: {}
    }
  },
  computed: {
    ...mapGetters('purchaseOrder/order', ['getProduct', 'getCostPrice']),
    default_currency_sign () {
      return this.$store.state.authUser.sys_setting.default_currency_sign
    },
    default_precision () {
      return this.$store.state.authUser.sys_setting.decimal_digit
    }
  },
  created () {
    this.model = this.value
  },
  methods: {
    onThbInput (row) {
      row.cost = _.round(
        row.cost_in_bath / this.model.fx_rate_thb,
        this.default_precision
      )
    },
    onUsdInput (row) {
      row.cost_in_bath = _.round(
        row.cost * this.model.fx_rate_thb,
        this.default_precision
      )
    },
    addItem (product) {
      let cost = 0

      if (product.sale_code[0] !== undefined) {
        if (product.sale_code[0].product_price !== undefined) {
          cost = product.sale_code[0].product_price.cost
        }
      }
      let row = {
        product_id: product.product_id,
        uom_id: product.uom_id,
        uom_cat_id: product.uom_cat_id,
        qty: product.qty ? product.qty : 1,
        maximum_reorder_allow: product.maximum_reorder_allow,
        alloworder: false,
        cost: _.round(product.cost, this.default_precision),
        cost_in_bath: _.round(product.cost_in_bath, this.default_precision),
        discount_rate: 0,
        discount_type: '%',
        total_after_discount: _.round(
          cost * (product.qty ? product.qty : 1),
          this.default_precision
        ),
        total_after_discount_in_bath:
          _.round(
            cost * (product.qty ? product.qty : 1),
            this.default_precision
          ) * this.model.fx_rate_thb
      }
      this.model.po_detail.push(row)
      this.$emit('calculate', row)
    }
  }
}
</script>

<style scoped>
.max-h {
  min-height: 50vh;
  max-height: 60vh;
  overflow: scroll;
}
</style>
